import { ReactNode, useContext } from "react"
import { motion } from "framer-motion"
import { ModalContext } from "../../context/ModalContext"
import { ReactComponent as CLOSE } from "../../assets/Close.svg"
import { useAccessibility } from "../../context/AccessibilityContext"

type BaseModalType = {
    children: ReactNode
    modalId?: number
    contact?: boolean
    small?: boolean
}

export default function BaseModal({ children, modalId, contact, small }: BaseModalType) {
    const modalCon = useContext(ModalContext)
    const { getCursorPointerClass } = useAccessibility()

    return (
        <div className={`fixed inset-0 overflow-hidden z-50 ${modalCon?.modalId === modalId && modalCon?.open ? "" : "hidden"}`}>
            <motion.div
                initial={{
                    opacity: 0,
                }}
                animate={{
                    opacity: modalCon?.animation ? 1 : 0,
                }}
                transition={{
                    duration: 0.2,
                    type: "ease",
                }}
                className="w-full bg-base-300/80 h-full z-40"
                onClick={() => modalCon?.trigger(0)}
            />
            <motion.div
                initial={{
                    scale: 0,
                }}
                animate={{
                    scale: modalCon?.animation ? 1 : 0,
                }}
                transition={{
                    duration: 0.2,
                    type: "ease",
                }}
                className={`w-full ${
                    contact ? "max-w-screen-xl" : small ? "max-w-content-sm h-fit" : "max-w-screen-lg grow h-screen lg:max-h-[48rem]"
                }  z-50 lg:rounded-default bg-base-200 shadow-lg absolute top-0 bottom-0 left-0 right-0 m-auto py-8 pl-8 pr-7 flex flex-col`}>
                <CLOSE
                    className={`w-12 h-12 absolute top-4 right-4 cursor-pointer z-[1000]  ${getCursorPointerClass()}`}
                    onClick={() => modalCon?.trigger(0)}
                />
                <div className="grow w-full overflow-x-hidden overflow-y-auto">{children}</div>
            </motion.div>
        </div>
    )
}
